import { IS_MOCK_MODE } from 'src/constants/featureFlag'
import { SERVER_URL } from 'src/constants/serverUrl'
import { TemplateResponse } from 'src/legacy_modules/entities/template/request'
import { requestPut } from 'src/legacy_modules/server/request'

export const requestRelease = async ({
  uid,
  trialUid,
}: {
  uid: string
  trialUid: string
}) => {
  if (IS_MOCK_MODE) {
    return {}
  }

  await requestPut<TemplateResponse>({
    url: `${SERVER_URL}/trials/${trialUid}/templates/${uid}/release`,
    params: {},
  })

  return {}
}
